import {
  StarIcon,
  StarOutlineIcon,
} from '@euler/app/tv/components/icons/StartIcon';
import { useAppLoading } from '@euler/components/loading/Provider';
import {
  useAddTaskBookmark,
  useRemoveTaskBookmark,
} from '@euler/functions/useTaskBookmarks';
import { TaskBookmarkSavePayload } from '@euler/model';
import { useServiceFactory } from '@euler/services/factory';
import { onErrorIgnore } from '@euler/utils';
import { usePersistFn } from '@euler/utils/hooks';
import { memo, useEffect, useState } from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';

export const TaskBookmarkStatusView = memo(
  ({
    payload,
    iconSize,
    iconColor,
    outlineIconColor,
    style,
  }: {
    payload: TaskBookmarkSavePayload;
    iconSize: number;
    iconColor: string;
    outlineIconColor: string;
    style?: StyleProp<ViewStyle>;
  }) => {
    const { taskNo } = payload;
    const { userService } = useServiceFactory();
    const [exists, setExists] = useState<boolean>();
    const appLoading = useAppLoading();

    useEffect(() => {
      userService
        .doesTaskBookmarkExist(taskNo)
        .then(res => {
          setExists(res);
        })
        .catch(onErrorIgnore);
    }, [taskNo, userService]);

    const addBookmark = useAddTaskBookmark();
    const removeBookmark = useRemoveTaskBookmark();

    const toggle = usePersistFn(async () => {
      await appLoading.showWithAction(async () => {
        if (exists) {
          await removeBookmark(taskNo);
          setExists(false);
        } else {
          await addBookmark(payload);
          setExists(true);
        }
      });
    });

    if (exists == null) {
      return null;
    }

    return (
      <TouchableOpacity style={style} onPress={toggle}>
        {exists ? (
          <StarIcon size={iconSize} color={iconColor} />
        ) : (
          <StarOutlineIcon size={iconSize} color={outlineIconColor} />
        )}
      </TouchableOpacity>
    );
  },
);
